module.exports = __webpack_public_path__ + "img/thumbnail_GreySeal_f_normal.635d7aa1.png";